import { DtoType } from "@core/data/dto/dto-types";
import { Dto } from '@core/data/dto/dto';
import { DTO_DEFAULT } from '@core/data/dto/dto-types';
import { DtoForceConstructor, DtoImport, DtoExport } from '@core/utils/dto';
import { BenefitSchema } from './benefit.schema';
import { Moment } from 'moment';
import { BenefitPeriod } from './benefit-period';

@DtoForceConstructor
export class Benefit {

    public id: string;
    public provider: string;
    public providerId: string;
    public period: BenefitPeriod;
    public description: string;
    public effectiveStart: Moment;
    public effectiveEnd: Moment;
    public companyContributionAmount: number;
    public companyContributionPercent: number;
    public companyPeriodAmount: number;
    public employeeContributionAmount: number;
    public employeeContributionPercent: number;
    public employeePeriodAmount: number;

    @DtoImport(BenefitSchema)
    static import(dto: Dto): any {
        return new Benefit(dto);
    }

    constructor(value?: any) {
        if (value) {
            const properties: string[] = Object.keys(value);

            properties.forEach((property: string) => {
                this[property] = value[property];
            });
        }
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: BenefitSchema,
        },
    ])
    export(type?: DtoType): any {}
}
